import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=63b84ee9&"
import script from "./Keyboard.vue?vue&type=script&lang=js&"
export * from "./Keyboard.vue?vue&type=script&lang=js&"
import style0 from "./Keyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports